import { Chip, MenuItem } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled.div`
  background: var(--bkg-tertiary);
  position: relative;
  width: calc(100vw - 20%);
  min-height: 100%;
  height: calc(100vh - 100px);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  padding-top: 24px;
  padding-bottom: 5%;
  gap: 5px;
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: var(--main-color);
    cursor: pointer;
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  background-color: var(--bkg-tertiary);
  height: 70px;
  flex-direction: column;
  justify-content: center;
  color: var(--main-color);
  margin: 0;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--text-primary);
  }

  p {
    color: var(--text-secondary);
  }
`;

export const SubtitleContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  color: var(--text-primary);
`;

export const StledChip = styled(Chip)`
  background-color: var(--bkg-quaternary);
  display: flex;
  justify-content: flex-start;
  padding-left: 10px;
  max-width: 125px;
  text-transform: capitalize;
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const StyledTable = styled.table`
  margin-top: 20px;
  width: 100%;
  border-collapse: collapse;
  & tbody > tr {
    color: #fff;
  }
`;

export const TableHeader = styled.th`
  color: var(--text-secondary);
  padding: 10px;
  padding-bottom: 24px;
  border: none;
  background-color: transparent;
  text-align: left;
  width: 250px;
`;

export const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid var(--bkg-quaternary);
  color: #fff;
  &:last-child {
    cursor: pointer;
  }
  & .MuiButtonBase-root svg {
    color: #fff;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &:last-child {
    padding-left: 40px !important;
  }
  & .MuiSvgIcon-root {
    font-size: 18px;
    margin-right: 8px;
  }
`;
